//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import _ from 'underscore'
// import DIC from '@/index/dictionary'

export default {
  props: {

  },
  data: function () {
    return {
      search: {
        beginTime: moment().format('YYYY-MM-DD'),
        endTime: moment().format('YYYY-MM-DD'),
        sortBy: 'sortByAmount'
      },
      sortOptions: [
        {value: 'sortByAmount', label: '销售金额'},
        {value: 'sortByCount', label: '销售数量'}
      ],
      page: {
        pageNo: 1,
        pageSize: 20,
        total: 0
      },
      loading: false,
      table: []
    }
  },
  watch: {
    'search.sortBy': {
      handler (val) {
        if (val) {
          this.handleLoadTableData()
        }
      }
    },
    'search.beginTime': {
      handler (val) {
        if (val) {
          this.handleLoadTableData()
        }
      }
    }
  },
  components: {

  },
  mounted () {

  },
  methods: {
    handleLoadTableData () {
      return new Promise((resolve, reject) => {
        this.loading = true
        let data = _.extend({}, _.omit(this.search, 'sortBy'), _.pick(this.page, 'pageNo', 'pageSize'))
        data[this.search.sortBy] = 1
        // console.log('data', data)
        this.$axios.get('/mtea/store/admin/report/goodsStatistics', { params: data }).then(res => {
          this.page.total = res.total
          this.table = res.records
        }).finally(() => {
          this.loading = false
          resolve()
        })
      })
    }
  }
}
